import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { SearchQueryPillWidget } from "@brandclub/bc-widgets";
const getFontWeight = (weight) => {
  const weightMap = {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  };
  return weightMap[weight] || 500;
};
const SearchQueryPill = ({
  query,
  products = [],
  totalResults = 0,
  isLoading = false,
  isAnimating = false,
  className
}) => {
  const displayProducts = products.slice(0, 4);
  const remainingCount = Math.max(0, totalResults - displayProducts.length);
  const hasProducts = displayProducts.length > 0;
  const showImagePlaceholder = isLoading || hasProducts;
  return /* @__PURE__ */ jsx(SearchQueryPillWidget, { widgetId: "search-query-pill", displayName: "Search Query Pill", children: (state, resolveColor) => /* @__PURE__ */ jsxs(
    "div",
    {
      className,
      style: {
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        backgroundColor: resolveColor(state.backgroundColor),
        border: `${state.borderWidth}px solid ${resolveColor(state.borderColor)}`,
        borderRadius: state.borderRadius,
        padding: `${state.paddingY}px ${state.paddingX}px`,
        transition: "all 0.3s",
        maxWidth: "100%",
        animation: isLoading ? "bcSubtlePulse 2.5s ease-in-out infinite" : void 0
      },
      children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            style: {
              fontSize: state.fontSize,
              fontWeight: getFontWeight(state.fontWeight),
              fontFamily: state.fontFamily,
              color: isLoading ? resolveColor(state.textColorLoading) : resolveColor(state.textColor),
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              minWidth: 0,
              transition: "color 0.3s"
            },
            title: query,
            children: query
          }
        ),
        showImagePlaceholder && /* @__PURE__ */ jsx("div", { style: { display: "flex", alignItems: "center", flexShrink: 0 }, children: isLoading ? (
          // Placeholder circles during loading
          [0, 1, 2, 3].map((idx) => /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                width: state.imageSize,
                height: state.imageSize,
                borderRadius: state.imageBorderRadius,
                backgroundColor: resolveColor(state.placeholderBgColor),
                border: `1px solid ${resolveColor(state.imageBorderColor)}`,
                flexShrink: 0,
                position: "relative",
                zIndex: 4 - idx,
                marginLeft: idx > 0 ? -state.imageOverlap : 0
              }
            },
            idx
          ))
        ) : (
          // Actual product images
          /* @__PURE__ */ jsxs(Fragment, { children: [
            displayProducts.map((product, idx) => /* @__PURE__ */ jsx(
              "a",
              {
                href: `/placeholder/p/${product.stacklineSku}`,
                target: "_blank",
                rel: "noopener noreferrer",
                title: product.title,
                style: {
                  width: state.imageSize,
                  height: state.imageSize,
                  borderRadius: state.imageBorderRadius,
                  overflow: "hidden",
                  backgroundColor: "#ffffff",
                  border: `1px solid ${resolveColor(state.imageBorderColor)}`,
                  flexShrink: 0,
                  display: "block",
                  position: "relative",
                  zIndex: displayProducts.length - idx,
                  marginLeft: idx > 0 ? -state.imageOverlap : 0,
                  opacity: isAnimating ? 0 : 1,
                  transform: isAnimating ? "scale(0.5)" : "scale(1)",
                  animation: isAnimating ? `pillProductFadeIn 0.4s ease-out ${idx * 100}ms forwards` : "none",
                  transition: "transform 0.3s"
                },
                children: /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: product.imageUrl,
                    alt: product.title,
                    style: { width: "100%", height: "100%", objectFit: "cover" }
                  }
                )
              },
              `${product.stacklineSku}-${idx}`
            )),
            remainingCount > 0 && /* @__PURE__ */ jsxs(
              "span",
              {
                style: {
                  fontSize: state.counterFontSize,
                  fontWeight: getFontWeight(state.fontWeight),
                  fontFamily: state.fontFamily,
                  color: resolveColor(state.counterTextColor),
                  marginLeft: "8px",
                  flexShrink: 0,
                  opacity: isAnimating ? 0 : 1,
                  animation: isAnimating ? `pillProductFadeIn 0.4s ease-out ${displayProducts.length * 100}ms forwards` : "none"
                },
                title: `${remainingCount} more products`,
                children: [
                  "+",
                  remainingCount
                ]
              }
            )
          ] })
        ) }),
        /* @__PURE__ */ jsx("style", { children: `
            @keyframes pillProductFadeIn {
              from {
                opacity: 0;
                transform: scale(0.5);
              }
              to {
                opacity: 1;
                transform: scale(1);
              }
            }
            @keyframes bcSubtlePulse {
              0%, 100% {
                opacity: 1;
              }
              50% {
                opacity: 0.65;
              }
            }
          ` })
      ]
    }
  ) });
};
export {
  SearchQueryPill
};
//# sourceMappingURL=SearchQueryPill.js.map
